import { useFlags, useLDClient } from "launchdarkly-react-client-sdk"

enum WelcomeScreenExperimentVariations {
  COPY_CHANGE = "copy-change",
  COPY_ICON_CHANGE = "copy-icon-change"
}

enum JourneySelectionScreenExperimentVariations {
  CONTROL = "control",
  AFTER_WELCOME_SCREEN = "after-welcome-screen",
  AFTER_PREF_NAME = "after-pref-name"
}

export function useExperiments() {
  const { welcomeScreenExperiment } = useFlags()

  const showCopyChange = welcomeScreenExperiment === WelcomeScreenExperimentVariations.COPY_CHANGE
  const showCopyIconChange = welcomeScreenExperiment === WelcomeScreenExperimentVariations.COPY_ICON_CHANGE

  return {
    showCopyChange,
    showCopyIconChange
  }
}

export function useJourneyExperiments() {
  const { journeySelectionInRegistrationExperiment } = useFlags()

  const control = journeySelectionInRegistrationExperiment === JourneySelectionScreenExperimentVariations.CONTROL
  const afterWelcomeScreen =
    journeySelectionInRegistrationExperiment === JourneySelectionScreenExperimentVariations.AFTER_WELCOME_SCREEN
  const afterPrefName =
    journeySelectionInRegistrationExperiment === JourneySelectionScreenExperimentVariations.AFTER_PREF_NAME

  return {
    control,
    afterWelcomeScreen,
    afterPrefName,
    journeySelectionInRegistrationExperiment
  }
}

export function useTrackExperimentEvent() {
  const ldClient = useLDClient()

  const trackExperimentEvent = async (eventName: string) => {
    if (ldClient) {
      try {
        await ldClient.waitUntilReady()
        ldClient.track(eventName)
      } catch (error) {
        reportError(error)
      }

      try {
        await ldClient.flush()
      } catch (error) {
        reportError(error)
      }
    }
  }

  return { trackExperimentEvent }
}
